import { captureException } from "@sentry/react";
import { Modal } from "components";
import React from "react";
import { Button } from "semantic-ui-react";

interface Props {
  title: string
  textContent?: string
  yesButtonLabel: string
  yesButtonColor: "red" | "green";
  onYes: () => Promise<any>
  onClose: () => void
}

const AreYouSureModal = (props: Props) => {
  const [isLoading, setIsLoading] = React.useState(false);
  const [hadError, setHadError] = React.useState(false);

  const onYes = async () => {
    setIsLoading(true);
    try {
      await props.onYes();
      props.onClose();
    } catch (e) {
      setHadError(true);
      setIsLoading(false);
      captureException(e);
      console.error(e);
    }
  };

  return <Modal
    isOpen
    handleClose={props.onClose}
    title={props.title}
  >
    {props.textContent ?? RESX.GeneralWarnings.AreYouSure}

    <div className="grow1">
    </div>
    {hadError && <div className="s1_red margin-bottom">{RESX.GeneralLabels.SomethingUnexpectedHappened}</div>}

    <div className="flex">
      <div className="grow1"></div>
      <Button disabled={isLoading} loading={isLoading} color={props.yesButtonColor} type="button" onClick={() => { onYes(); }}>
        {props.yesButtonLabel}
      </Button>
    </div>
  </Modal>;
};

export default AreYouSureModal;
